import { render, staticRenderFns } from "./EtapasHeader.vue?vue&type=template&id=830e69ae&scoped=true&"
import script from "./EtapasHeader.vue?vue&type=script&lang=js&"
export * from "./EtapasHeader.vue?vue&type=script&lang=js&"
import style0 from "./EtapasHeader.vue?vue&type=style&index=0&id=830e69ae&lang=scss&scoped=true&"
import style1 from "./EtapasHeader.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "830e69ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperHeader } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
installComponents(component, {VDivider,VStepper,VStepperHeader,VStepperStep})
